import { apiProxyRequest } from "Api/apiProxyRequest";

export type ProjectAddons = {
  available: Record<string, Record<string, number> | undefined>;
  upgrades_available: Record<string, string[] | undefined>;
  current: Record<string, Record<string, number> | null | undefined>;
};

export const getProjectAddonsRequest = ({
  organizationId,
  subscriptionId
}: {
  organizationId: string;
  subscriptionId: string;
}) =>
  apiProxyRequest<ProjectAddons>(
    `/organizations/${organizationId}/subscriptions/${subscriptionId}/addons`
  );
